import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import Layout from "./components/Layout.jsx";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Categories from "./pages/Categories.jsx";
import Uploads from "./pages/Uploads.jsx";
import DatabaseManager from "./pages/DatabaseManager.jsx";
import QueryBuilder from "./pages/QueryBuilder.jsx";
import QueryResults from "./components/QueryResults.jsx";
import DuplicateResults from "./pages/DuplicateResults.jsx";

import UserManagement from "./pages/UserManagement.jsx";

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="categories" element={<Categories />} />
          <Route path="uploads" element={<Uploads />} />
          <Route path="database" element={<DatabaseManager />} />
          <Route path="query" element={<QueryBuilder />} />
          <Route path="query-builder" element={<QueryBuilder />} />
          <Route path="query-results" element={<QueryResults />} />
          <Route path="duplicate-results" element={<DuplicateResults />} />

          <Route path="users" element={<UserManagement />} />
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
